import { Database } from '@nozbe/watermelondb'
import { ComponentInfoChatVO } from '@repo/types'
import { Chat } from '../model'
import { findChatByConnectionKeyAndPhoneNumber } from '../readers'

export const addChat = async (payload: ComponentInfoChatVO, database: Database): Promise<Chat> => {
  const { connectionKey, phoneNumber } = payload

  const chats = database.collections.get<Chat>('chats')
  const chat = await findChatByConnectionKeyAndPhoneNumber(connectionKey, phoneNumber, database)

  return database.write(async () => {
    if (!chat) {
      return chats.create((it: Chat) => it.setChatByComponentInfoChatVO(payload))
    }
    return chat.update((it: Chat) => it.setChatByComponentInfoChatVO(payload))
  })
}
